import DemoTravelRuleTableFilter from './DemoTravelRuleTableFilter'

export default DemoTravelRuleTableFilter
